<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import InsightsListView from '@/views/InsightsListView.vue';
import InsightActionBar from '@/components/insights/InsightActionBar.vue';
import InsightContent from '@/components/insights/InsightContent.vue';
import ThreeColumnLayout from '@/components/_common/ThreeColumnLayout.vue';
import { ref, computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';

const searchQuery = ref('');

import { useSynchronizedUrlQuerySearchStore } from '@/composables/useSynchronizedUrlQuerySearchStore';
useSynchronizedUrlQuerySearchStore();

import { useSynchronizedSidebars } from '@/composables/useSynchronizedSidebars';
const { isLeftSidebarOpen } = useSynchronizedSidebars({
  persistScoutOpenState: true,
});

import { useResetChatOnSidebarClose } from '@/composables/useResetChatOnSidebarClose';
useResetChatOnSidebarClose();

import { useResetChatOnAccountOrUserChange } from '@/composables/useResetChatOnAccountOrUserChange';
import CommonSearch from '@/components/_common/CommonSearch.vue';
import { topBarInsetClass } from '@/components/_common/navbar/topBarInset';
useResetChatOnAccountOrUserChange();

const route = useRoute();
const showContent = computed(() => !!route.params.id);

watchEffect(() => {
  if (!route.params.id) {
    isLeftSidebarOpen.value = true;
  }
});
</script>

<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <div :class="topBarInsetClass">
        <CommonSearch placeholder="Search Insights..." />
      </div>
    </template>
    <template #left>
      <InsightsListView :search-query="searchQuery" />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
          <InsightActionBar v-if="showContent" />
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <InsightContent v-if="showContent" />
      <div v-else class="flex h-full items-center justify-center text-gpx_gray-700">
        <p>Select an insight to view details</p>
      </div>
    </template>
  </ThreeColumnLayout>
</template>
